import "core-js/modules/es7.array.includes.js";
import pipelineStatusValues from 'utils/pipelineStatusValues';
var calculateQCRerunStatus = function calculateQCRerunStatus(qcBackendStatus, gem2sBackendStatus, isImmuneOnly) {
  var qcRerunReason = 'the cell level metadata file has changed since the experiment was last processed';
  var _ref = qcBackendStatus !== null && qcBackendStatus !== void 0 ? qcBackendStatus : {},
    status = _ref.status;
  var pipelineSuccessful = [pipelineStatusValues.SUCCEEDED, pipelineStatusValues.RUNNING].includes(status);

  // If gem2s hasn't finished, qc doesn't require reruns because
  // it will be triggered automatically by gem2s finishing
  var rerun = gem2sBackendStatus.status === pipelineStatusValues.SUCCEEDED && qcBackendStatus.shouldRerun
  // immune only experiments dont show the qc page so non-successful qc pipeline
  // needs to return a rerun for the whole pipeline
  || isImmuneOnly && !pipelineSuccessful;
  return {
    rerun: rerun,
    reasons: qcBackendStatus.shouldRerun ? [qcRerunReason] : [],
    complete: qcBackendStatus.status === pipelineStatusValues.SUCCEEDED && gem2sBackendStatus.status === pipelineStatusValues.SUCCEEDED
  };
};
export default calculateQCRerunStatus;